{
  "version": 1,
  "asset_id": "3de8576c-0e9b-426b-a195-bc483a36cfe7",
  "project_id": "b5943ba6-0f61-4928-b23c-a966ef99f6df",
  "url": "/__l5e/assets-v1/3de8576c-0e9b-426b-a195-bc483a36cfe7/celina-collection-result-new.png",
  "r2_key": "a/v1/b5943ba6-0f61-4928-b23c-a966ef99f6df/3de8576c-0e9b-426b-a195-bc483a36cfe7/celina-collection-result-new.png",
  "original_filename": "celina-collection-result-new.png",
  "size": 1058410,
  "content_type": "image/png",
  "created_at": "2026-09-23T21:17:27Z"
}
